var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.883,
    height: 14.881,
    viewBox: "0 0 14.883 14.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20253a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.379,19.819a7.441,7.441,0,1,1,7.441-7.441A7.45,7.45,0,0,1,12.379,19.819Zm1.607-9.84a.726.726,0,0,0-1.027-1.026l-2.912,2.913a.726.726,0,0,0,0,1.027L12.959,15.8a.726.726,0,1,0,1.027-1.026l-2.4-2.4Z",
    transform: "translate(-4.938 -4.938)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/backArrowIcon.7c6529d500c3feaef7a7e8597773c314.svg";
export { ForwardRef as ReactComponent };